import React from "react";
import { useTheme } from "../contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import loaderImage from "../assets/loaderimage.avif";

export default function Loader() {
  const { theme } = useTheme();
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "fa" || i18n.language === "ps";

  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center ${
        theme === "dark" ? "bg-[#0B0E14]" : "bg-gray-100"
      }`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      {/* Brand Icon */}
      <div className="mb-4">
        <img
          src={loaderImage}
          alt={t("navbar.brandColored") + " " + t("navbar.brandUncolored")}
          className="w-16 h-16"
        />
      </div>

      {/* Brand Logo */}
      <div className="text-4xl font-bold tracking-tight mb-8">
        <span className="text-orange-500">
          {t("navbar.brandColored")}
        </span>{" "}
        <span
          className={
            theme === "dark" ? "text-gray-100" : "text-gray-900"
          }
        >
          {t("navbar.brandUncolored")}
        </span>
      </div>

      {/* Progress Bar Container */}
      <div className="w-full max-w-md h-1 overflow-hidden bg-gray-300/20 relative">
        {/* Moving bar */}
        <div
          className={`absolute top-0 h-full w-1/3 bg-orange-500 ${
            isRTL ? "right-0 animate-progress-rtl" : "left-0 animate-progress"
          }`}
        />
      </div>

      <style>{`
        @keyframes progress {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(300%);
          }
        }

        @keyframes progress-rtl {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-300%);
          }
        }

        .animate-progress {
          animation: progress 1s linear infinite;
        }

        .animate-progress-rtl {
          animation: progress-rtl 1s linear infinite;
        }
      `}</style>
    </div>
  );
}